export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    return {
        entityDetails: {
            ...entityDetails,
        },
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && { appProfileDetails: { label: entityDetails?.name, value: entityDetails?.name } }),
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.applicationRegion || null,
        department: catalogConfig?.department || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.applicationShortName || null,
        appUrl: catalogConfig?.applicationUrl || null,
        supportBackendCertificate: catalogConfig?.supportBackendCertificate || null,
        adCertGroup: catalogConfig?.activeDirectoryCertificateGroup || null,
        dataClassification: catalogConfig?.dataClassification || null,
        appSupportMailId: catalogConfig?.appSupportMailId || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        ...(catalogConfig?.environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: environmentDetails?.awsAccountId,
        availabilityZone:
            catalogConfig?.availabilityZone?.map((item) => ({
                label: item,
                value: item,
            })) || null,
        loadBalancerType: catalogConfig?.onboardingType,
        isAlbRequired: catalogConfig?.internalAlbExists ? 'yes' : 'no',
        albName: catalogConfig?.internalAlbName || null,
        albRuleName: catalogConfig?.albRuleName || null,
        nlbName: catalogConfig?.internalNlbName || null,
        albNameInternal: catalogConfig?.internalAlbName || null,
        albArn: catalogConfig?.internalAlbArn || null,
        nlbNameInternal: catalogConfig?.internalNlbName || null,
        nlbArn: catalogConfig?.internalNlbArn || null,
        instanceId: catalogConfig?.internalAlbExists === true && catalogConfig?.internalAlbTargetInstanceIds?.length ? 'yes' : 'no',
        targets: catalogConfig?.internalAlbTargetInstanceIds || [],
        isNlbRequired: catalogConfig?.internalNlbExists ? 'yes' : 'no',
        isAlbRuleRequired: catalogConfig?.isAlbRuleRequired ? 'yes' : 'no',
        listenerPort: catalogConfig?.listeners?.port,
        listenerProtocol: catalogConfig?.listeners?.protocol,
        targetGrpName: catalogConfig?.internalAlbTargetGroup?.name,
        targetGrpNameNlb: catalogConfig?.internalNlbTargetGroupName || null,
        targetGrpNameNlbArn: catalogConfig?.internalNlbTargetGroupName || null,
        targetType: catalogConfig?.internalAlbTargetGroup?.targetType,
        // Always set targetsDetail as an array of objects for multi-select compatibility
        targetsDetail: Array.isArray(catalogConfig?.internalAlbTargetGroup?.instanceId)
            ? catalogConfig?.internalAlbTargetGroup?.instanceId?.map((id, idx) => ({
                  id,
                  data: {
                      id,
                      ip: Array.isArray(catalogConfig?.internalAlbTargetGroup?.ip) ? catalogConfig?.internalAlbTargetGroup?.ip[idx] : undefined,
                  },
              }))
            : [],
        targetProtocol: catalogConfig?.internalAlbTargetGroup?.protocol,
        targetPort: catalogConfig?.internalAlbTargetGroup?.port,
        isCrossNameRequired: catalogConfig?.internalAlbTargetGroup?.crossOriginRequired === true ? 'yes' : 'no',
        ...(catalogConfig?.internalAlbTargetGroup?.crossOriginRequired === true && {
            targetAppProfile: catalogConfig?.internalAlbTargetGroup?.crossAppProfile || null,
            targetSector: catalogConfig?.internalAlbTargetGroup?.crossSector || null,
            targetDepartment: catalogConfig?.internalAlbTargetGroup?.crossDepartment || null,
            targetCrossAccount: catalogConfig?.internalAlbTargetGroup?.crossAccount || null,
            targetCrossAccountId: catalogConfig?.internalAlbTargetGroup?.crossAccountId || null,
            ips: Array.isArray(catalogConfig?.internalAlbTargetGroup?.ip) ? catalogConfig?.internalAlbTargetGroup?.ip : [],
        }),
        hcProtocol: catalogConfig?.healthCheck?.protocol,
        hcPath: catalogConfig?.healthCheck?.path,
        hcPort: catalogConfig?.healthCheck?.port,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    entityDetails: null,
    appProfile: null,
    applicationName: null,
    sector: null,
    sectorDetails: null,
    department: null,
    appRegion: null,
    environment: null,
    hCode: null,
    hCodeDetails: null,
    appUrl: null,
    appOwner: null,
    appOwnerDetails: null,
    dataClassification: null,
    adCertGroup: null,
    appSupportMailId: null,
    landingZoneDetails: null,

    // Resource Section
    awsAccount: null,
    awsAccountId: null,
    availabilityZone: [],
    loadBalancerType: 'internal',
    supportBackendCertificate: null,
    isAlbRequired: null,
    // Yes Scenario
    albNameInternal: null,
    albArn: null,
    instanceId: 'yes',
    targets: [],
    targetsDetail: [],
    // No Scenario
    appShortName: null,
    albName: null,
    targetGrpName: null,
    targetGrpNameNlb: null,
    listenerPort: 443,
    listenerProtocol: 'HTTPS',
    targetType: 'instance',
    targetPort: null,
    targetProtocol: null,
    hcProtocol: null,
    hcProtocolDetail: null,
    hcPath: null,
    hcPort: null,
    isNlbRequired: null,
    // Yes Scenario
    nlbNameInternal: null,
    nlbArn: null,
    targetGrpNameNlbArn: null,
    // No Scenario
    nlbName: null,
    // appShortName: null,

    // Track which load balancer was set to "no" first for AppShortName cross-dependency
    albNoFirst: false,
    nlbNoFirst: false,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const environmentConfigAppURL = {
    development: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.dev\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.dev.mypepsico.com, <appshortname>.dev.pepsico.com, or <appshortname>.dev.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.dev.mypepsico.com).`,
    },
    qa: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.qa\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.qa.mypepsico.com, <appshortname>.qa.pepsico.com, or <appshortname>.qa.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.qa.pepsico.com).`,
    },
    'pre-production': {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.preprod\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.preprod.mypepsico.com, <appshortname>.preprod.pepsico.com, or <appshortname>.preprod.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.preprod.pepsico.com).`,
    },
    production: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.mypepsico.com, <appshortname>.pepsico.com, or <appshortname>.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.pepsico.com).`,
    },
};

export const validateAppURL = (url, environment) => {
    const config = environmentConfigAppURL[environment?.toLowerCase()];

    if (!config) {
        return {
            isValid: false,
            message: 'Invalid environment specified',
        };
    }
    let isValid = {
        isValid: true,
        message: '',
    };
    if (url !== null && url !== '') {
        isValid = config.regex.test(url);
    }
    return {
        isValid,
        message: isValid ? 'Valid URL' : config.message,
    };
};

export const isAppShortNameDisabled = (order, baseDisabled = false, componentContext = null) => {
    if (baseDisabled) {
        return true;
    }

    // If both ALB and NLB are "no" and there's an appShortName
    const bothRequireNo = order?.isAlbRequired === 'no' && order?.isNlbRequired === 'no';
    const hasAppShortName = order?.appShortName && order?.appShortName.trim() !== '';

    if (bothRequireNo && hasAppShortName) {
        // Check which load balancer was set to "no" first using a timestamp or priority
        // For now, use a simple rule: if both are "no", the first one that was interacted with stays enabled
        // We can track this using order.albNoFirst or order.nlbNoFirst flags

        if (order?.albNoFirst && componentContext === 'nlb') {
            return true; // Disable NLB if ALB was set to "no" first
        }
        if (order?.nlbNoFirst && componentContext === 'alb') {
            return true; // Disable ALB if NLB was set to "no" first
        }
    }

    return false;
};

export const getDefaultCertificate = (order) => {
    const { isValid } = validateAppURL(order?.appUrl, order?.environment);
    if (isValid) {
        if (order?.appUrl) {
            if (/^([a-zA-Z0-9-]{3,20})\.(mypepsico|pepsico)\.com$|^([a-zA-Z0-9-]{3,20})\.(dev|qa|preprod|ite)\.(mypepsico|pepsico)\.com$/.test(order?.appUrl)) {
                return 'Entrust Certificate';
            }
            if (
                /^([a-zA-Z0-9-]{3,20})\.(aws\.intra\.pepsico)\.com$|^([a-zA-Z0-9-]{3,20})\.(dev|qa|preprod|ite)\.(aws\.intra\.pepsico)\.com$/.test(
                    order?.appUrl
                )
            ) {
                return 'Pepsico Enterprise CA Certificate';
            }
        }
    }
    return null;
};

export const isCrossDependencyActive = (order) => {
    return order?.isAlbRequired === 'no' && order?.isNlbRequired === 'no';
};
export const costPayload = ({ order = [], catalogCode }) => {
    return {
        catalogServiceCode: catalogCode,
        quantity: 1,
        catalogConfig: {
            environmentDetails: {
                region: order?.landingZoneDetails?.region,
                environment: order?.environment,
            },
        },
        supportBackendCertificate: getDefaultCertificate(order),
    };
};

export const getAppShortNameHelperText = (order) => {
    if (isCrossDependencyActive(order) && order?.appShortName) {
        return 'Application Short Name is shared between ALB and NLB configurations.';
    }
    return null;
};

export const setLoadBalancerNoFirst = (order, setOrder, loadBalancerType) => {
    // Set the flag when a load balancer is set to "no" for the first time
    if (loadBalancerType === 'alb' && !order?.albNoFirst && !order?.nlbNoFirst) {
        setOrder({
            ...order,
            albNoFirst: true,
        });
    } else if (loadBalancerType === 'nlb' && !order?.nlbNoFirst && !order?.albNoFirst) {
        setOrder({
            ...order,
            nlbNoFirst: true,
        });
    }
};

export const resetLoadBalancerFlags = (order, setOrder) => {
    // Reset flags when neither load balancer requires "no"
    if (order?.isAlbRequired !== 'no' && order?.isNlbRequired !== 'no') {
        setOrder({
            ...order,
            albNoFirst: false,
            nlbNoFirst: false,
            appShortName: null, // Clear appShortName when resetting
        });
    }
};
